import React, { useEffect } from 'react';
import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { GallerySection } from '../components/GallerySection';
import { businessInfo } from '../mockData';

export const OurWorkPage = () => {
  useEffect(() => {
    document.title = "Our Work Gallery | Dezire Metal Roofing Sydney";
  }, []);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/bqktg9bw_18b8e293-a942-4090-b7ab-1595eb0f0314.jpeg')] bg-cover bg-center opacity-20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Our <span className="text-primary">Work Gallery</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              See the quality of our workmanship across Greater Sydney. Real projects, real results.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <GallerySection />

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Want Results Like These?</h2>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
            Join our growing list of satisfied customers. Contact us today for your free inspection.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/book-inspection">
              <Button size="lg" className="bg-primary hover:bg-accent text-white">
                Book Free Inspection
              </Button>
            </Link>
            <a href="/call">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-gray-900">
                <Phone className="w-5 h-5 mr-2" />
                Call {businessInfo.phone}
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
